import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { fetchWorkshop, loadWorkshopSessions } from '../../dashboard/common/actions';
import WorkshopSessionsComponent from '../../dashboard/booking/workshop/Sessions';
import { selectWorkshopSessions, startWorkshopEnrolment } from '../../dashboard/booking/actions';

class WorkshopSessions extends Component {
	constructor(props) {
		super(props);

		this.handleSessionsSelect = this.handleSessionsSelect.bind(this);
		this.handleNavigateBack = this.handleNavigateBack.bind(this);
	}

	componentDidMount() {
		const { centerId, workshopId, fetchWorkshop, loadWorkshopSessions, resetBooking } = this.props;
		fetchWorkshop(centerId, workshopId);
		loadWorkshopSessions(centerId, workshopId);
	}

	handleSessionsSelect(sessionIds) {
		const { workshop, center } = this.props;

		this.props.selectWorkshopSessions(sessionIds);
		this.props.startWorkshopEnrolment({
			workshop,
			center,
			quantity: sessionIds.length
		});
		this.props.history.push('/register', { from: `/workshop/booking/${this.props.centerId}/${this.props.workshopId}/child` });
	}

	handleNavigateBack() {
		this.props.history.push(`/public/workshops/${this.props.centerId}/${this.props.workshopId}`);
	}

	render() {
		return <WorkshopSessionsComponent
			workshop={this.props.workshop}
			workshopSessions={this.props.workshopSessions}
			currentUser={this.props.currentUser}
			bookingOptions={this.props.bookingOptions}
			onSelectSessions={this.handleSessionsSelect}
			onNavigateBack={this.handleNavigateBack}
			enableUserTimeZone={this.props.enableUserTimeZone}
			limitToShowLeftWorkshopSpots={this.props.limitToShowLeftWorkshopSpots}
			center={this.props.selectedCenter}
			block={[]}
			unblock={[]}
		/>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const centerId = Number(ownProps.match.params.centerId);
	const workshopId = Number(ownProps.match.params.workshopId);

	const {
		entities: { centers, workshops, workshopSessions },
		configuration: { franchisor },
		auth: { currentUser }
	} = state;

	const {
		selectedWorkshopSessionIds,
		workshopErrorMessage
	} = state.booking;

	const selectedCenter = centers[centerId];
	const workshopSessionsFilter = state.filters.workshopSessions[workshopId] || { ids: [] };

	const now = new Date();

	return {
		centerId,
		workshopId,
		center: selectedCenter,
		workshop: workshops[workshopId],
		workshopSessions: workshopSessionsFilter.ids.map(id => {
			const session = workshopSessions[id];
			return session && {
				...session,
				upcoming: selectedCenter ? moment(session.start).utcOffset(selectedCenter.utcOffset, true) > now : false		// actual start time using center's timezone
			};
		}),
		currentUser,
		enableUserTimeZone: franchisor.enableUserTimeZone,
		limitToShowLeftWorkshopSpots: franchisor.limitToShowLeftWorkshopSpots,
		bookingOptions: {
			selectedWorkshopSessionIds,
			errorMessage: workshopErrorMessage
		}
	};
};

export default connect(mapStateToProps, {
	fetchWorkshop,
	loadWorkshopSessions,
	selectWorkshopSessions,
	startWorkshopEnrolment
})(withTranslation()(WorkshopSessions));